// WhatsApp-Textpool Serientermine (Fallback-Locale)
export default {
  "winterdoppel.whatsapp.tone.funny.autumn.intro.01":
    "Blätter fallen, Bälle fliegen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.02":
    "Herbstwind draußen – Topspin drinnen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.03":
    "Die Hallenlichter sind an: Doppel-Time!",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.04":
    "Kürbiszeit? Nein: Court-Zeit!",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.05":
    "Nebel draußen, klare Bälle innen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.06":
    "Mantel aus, Schläger raus.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.07":
    "Goldener Oktober auf dem Asphalt der Halle.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.08":
    "Laub kehren wir später – erst spielen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.09":
    "Regen draußen, Return drinnen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.10":
    "Herbst-Special: Wer kommt ohne Ausrede?",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.11":
    "Die Saison knistert – wer ist warm?",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.12":
    "Outdoor vorbei, Doppel beginnt.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.13":
    "Schuhe schnüren, Blätter ignorieren.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.14":
    "Hallensaison-Modus: aktiviert.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.15":
    "Frischluft war gestern – heute: Netz.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.16":
    "Der Herbst liefert Stimmung, wir liefern Bälle.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.17":
    "Jacke bleibt an der Garderobe, Ego auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.18":
    "Wer den ersten Ball verzieht, spendiert Glühwein… später.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.19":
    "Herbst-Doppel: kurzärmlig im Herzen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.20":
    "Wind draußen, Slice drinnen.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.21":
    "Die Plätze warten – und eure Vorhand auch.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.22":
    "Saison-Kick: Wer bringt die beste Ausrede mit?",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.23":
    "Nach der Arbeit: Aufschlag statt Ampel.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.24":
    "Herbst-Playlist: Plopp, Plopp, „Aus!“",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.25":
    "Draußen Matsch, drinnen Match.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.26":
    "Die Uhr steht auf Doppel.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.27":
    "Wer fehlt, verpasst den Herbst-Hit.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.28":
    "Hallenluft schlägt Oktoberwind.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.29":
    "Komm vorbei – die Bälle sind schon nervös.",
  "winterdoppel.whatsapp.tone.funny.autumn.intro.30":
    "Kurz gesagt: Wir spielen. Ihr?",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.01":
    "Wer kommt wirklich – und wer hat wieder Ausreden parat? 😄",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.02":
    "Bitte kurz melden: dabei oder klassische Ausrede?",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.03":
    "Daumen hoch / runter – oder kreative Absage?",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.04":
    "Rückmeldung bitte, sonst plane ich mit Geisterspielern.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.05":
    "Sagt Bescheid, bevor der Herbst euch einholt.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.06":
    "Melden lohnt sich – Ausreden sammeln wir sonst ein.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.07":
    "Kurz ja/nein – danke euch!",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.08":
    "Wer zusagt, kriegt Ruhm. Wer absagt, kriegt Memes.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.09":
    "Bitte antworten, sonst rufe ich eure Vorhand persönlich an.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.10":
    "Feedback erbeten – höflich, aber bestimmt 😉",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.11":
    "Kommt ihr – oder soll ich den Platz umbuchen?",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.12":
    "Eine Nachricht reicht. Versprochen.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.13":
    "Bitte melden, dann steht die Aufstellung.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.14":
    "Ja = Held. Nein = ehrlich. Schweigen = mysteriös.",
  "winterdoppel.whatsapp.tone.funny.autumn.cta.15":
    "Kurzes Lebenszeichen bitte!",
  "winterdoppel.whatsapp.tone.funny.winter.intro.01":
    "Frostbeule-Alarm – wer traut sich? 🥶",
  "winterdoppel.whatsapp.tone.funny.winter.intro.02":
    "Draußen Eiszeit, drinnen Matchzeit.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.03":
    "Handschuhe aus, Schläger an!",
  "winterdoppel.whatsapp.tone.funny.winter.intro.04":
    "Wintermodus: Hallenheizung + Vorhand.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.05":
    "Schnee draußen? Egal. Doppel innen.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.06":
    "Die Bälle sind kalt – wir wärmen sie auf.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.07":
    "Glühwein später, Return jetzt.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.08":
    "Wer friert, spielt härter.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.09":
    "Serientermin: heiß auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.10":
    "Jacke bleibt draußen, Mut kommt mit.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.11":
    "Eisige Straßen, warme Volleys.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.12":
    "Der Winter testet eure Motivation.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.13":
    "Hallenlicht schlägt Mondschein.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.14":
    "Kälte draußen, Tempo drinnen.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.15":
    "Aufschlag gegen den Winterblues.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.16": "Wer kommt, taut auf.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.17":
    "Schnee schippen war gestern – heute: Slice.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.18":
    "Die Halle hat Platz. Habt ihr Zeit?",
  "winterdoppel.whatsapp.tone.funny.winter.intro.19":
    "Winter-Special: weniger Ausreden, mehr Bälle.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.20": "Mütze ab, Fokus an.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.21":
    "Frostige Begrüßung, heiße Duelle.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.22":
    "Der Court heizt sich mit euch auf.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.23":
    "Winterzeit = Doppelzeit.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.24":
    "Nur Mut – die Bälle beißen nicht… meistens.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.25":
    "Kalt starten, warm finishen.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.26":
    "Die Saison braucht euch – und eure Beine.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.27":
    "Winter-Edition: Wer bringt die beste Vorhand mit?",
  "winterdoppel.whatsapp.tone.funny.winter.intro.28":
    "Draußen quietschen die Reifen, drinnen die Schuhe.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.29":
    "Kommt rein, bevor ihr festfriert.",
  "winterdoppel.whatsapp.tone.funny.winter.intro.30":
    "Kurz: Wir spielen trotz Wetterbericht.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.01":
    "Melden oder es gibt nur noch kalte Bälle. ❄️",
  "winterdoppel.whatsapp.tone.funny.winter.cta.02":
    "Bitte zusagen – sonst wird’s einsam am Netz.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.03":
    "Kurzes Ja/Nein gegen den Winterblues!",
  "winterdoppel.whatsapp.tone.funny.winter.cta.04":
    "Wer kommt, wärmt sich auf. Wer schweigt, friert.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.05": "Rückmeldung bitte, danke!",
  "winterdoppel.whatsapp.tone.funny.winter.cta.06":
    "Sagt Bescheid, bevor die Heizung ausgeht.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.07":
    "Antwort erbeten – frostfrei.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.08":
    "Ja schreiben reicht völlig.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.09":
    "Bitte melden, dann steht der Plan.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.10":
    "Kommt ihr mit – oder bleibt ihr im Iglu?",
  "winterdoppel.whatsapp.tone.funny.winter.cta.11":
    "Kurzes Lebenszeichen gegen die Kälte.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.12":
    "Feedback bitte – höflich und warm.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.13":
    "Zusagen willkommen, Ausreden auch (ehrlich).",
  "winterdoppel.whatsapp.tone.funny.winter.cta.14":
    "Meldet euch, sonst plane ich mit Schneemännern.",
  "winterdoppel.whatsapp.tone.funny.winter.cta.15":
    "Eine Nachricht – dann wissen wir Bescheid.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.01":
    "Frühling! Die Netze sind aufgetaut. 🌷",
  "winterdoppel.whatsapp.tone.funny.spring.intro.02":
    "Allergie? Egal – Tennis heilt.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.03":
    "Frühjahrsmüdigkeit? Wir haben das Gegenmittel.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.04":
    "Die Tage werden länger, eure Vorhand auch.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.05":
    "Pollenflug draußen, Topspin drinnen.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.06":
    "Frühling in der Halle: frischer Wind am Netz.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.07":
    "Osterpause war gestern – Doppel heute.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.08":
    "Die Sonne kommt, ihr hoffentlich auch.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.09":
    "Frühlingsgefühle: Return & Lächeln.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.10":
    "Aufgetaut und aufschlagbereit.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.11":
    "Neue Saisonluft – alte Rivalitäten.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.12":
    "Wer blüht auf? Wir auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.13":
    "Frühlingsspecial: weniger Ausreden.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.14":
    "Die Bälle hüpfen wieder freudiger.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.15":
    "Frisch gewagt ist halb gewonnen.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.16":
    "Grün draußen, Grün-Weiß drinnen.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.17":
    "Zeit für Doppel statt Daylight Saving Ausreden.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.18":
    "Die Halle freut sich auf euch.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.19":
    "Frühlingshit: Wer kommt ohne Drama?",
  "winterdoppel.whatsapp.tone.funny.spring.intro.20":
    "Aufblühen könnt ihr beim Smash.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.21":
    "Leichte Luft, schwere Bälle – perfekt.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.22":
    "Saisonfinale naht – nochmal Vollgas.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.23":
    "Frühling heißt: nochmal richtig zulegen.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.24":
    "Die Plätze sind warmgelaufen.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.25":
    "Kommt vorbei, bevor der Sommer alles ändert.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.26":
    "Frischer Kopf, frische Vorhand.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.27":
    "Wir spielen, die Vögel klatschen (mental).",
  "winterdoppel.whatsapp.tone.funny.spring.intro.28":
    "Frühling-Doppel: gute Laune Pflicht.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.29":
    "Wer fehlt, verpasst den Saison-Glow.",
  "winterdoppel.whatsapp.tone.funny.spring.intro.30":
    "Kurz: Es geht wieder bergauf – mit euch?",
  "winterdoppel.whatsapp.tone.funny.spring.cta.01":
    "Bitte kurz melden – Frühling wartet nicht.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.02": "Ja/Nein reicht, danke!",
  "winterdoppel.whatsapp.tone.funny.spring.cta.03":
    "Wer kommt zum Saison-Endspurt?",
  "winterdoppel.whatsapp.tone.funny.spring.cta.04":
    "Rückmeldung bitte, sonst plane ich mit Osternestern.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.05":
    "Sagt Bescheid – wir zählen auf euch.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.06":
    "Kurzes Lebenszeichen erbeten.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.07":
    "Melden lohnt sich (Sonnenbonus inklusive).",
  "winterdoppel.whatsapp.tone.funny.spring.cta.08":
    "Antwort bitte, bevor die Pollen siegen.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.09": "Zusagen willkommen!",
  "winterdoppel.whatsapp.tone.funny.spring.cta.10":
    "Eine Nachricht – und der Plan steht.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.11": "Kommt ihr mit Schwung?",
  "winterdoppel.whatsapp.tone.funny.spring.cta.12":
    "Bitte Feedback, danke euch.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.13":
    "Ja schreiben, Drama sparen.",
  "winterdoppel.whatsapp.tone.funny.spring.cta.14":
    "Meldet euch kurz – Frühlingstempo!",
  "winterdoppel.whatsapp.tone.funny.spring.cta.15":
    "Wer zusagt, blüht auf. Versprochen.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.01":
    "Ho ho ho – wer war brav und kommt zum Doppel? 🎅",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.02":
    "Nikolaus checkt die Teilnehmerliste. 📜",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.03":
    "Stiefel raus, Schläger rein!",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.04":
    "Wer brav war, darf returnen.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.05":
    "Nikolaus-Special: Süßes Match oder saure Ausrede?",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.06":
    "Die Rute bleibt zu Hause – die Vorhand nicht.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.07":
    "Nikolaus fragt: Wer spielt mit?",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.08":
    "Geschenke später, Doppel jetzt.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.09":
    "Wer kommt, steht auf der Guten-Liste.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.10":
    "Nikolaus-Edition: Hallen-Zauber.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.11":
    "Stiefel voller Motivation gesucht.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.12":
    "Hohoho – die Plätze sind geschmückt (mental).",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.13":
    "Nikolaus pfeift zum Aufschlag.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.14":
    "Wer absagt, kriegt Kohle… nein, Memes.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.15":
    "Festliche Laune, ernsthafte Bälle.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.16":
    "Nikolaus-Check: Schläger poliert?",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.17":
    "Rote Mütze optional, Pünktlichkeit nicht.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.18":
    "Die Nacht vor dem Doppel…",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.19":
    "Nikolaus bringt Stimmung, ihr die Vorhand.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.20":
    "Wer brav trainiert hat: jetzt zeigen.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.21":
    "Süßigkeiten nach dem Match – vielleicht.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.22":
    "Nikolaus-Doppel: Tradition meets Topspin.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.23":
    "Die Liste ist offen – tragt euch ein.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.24": "Ho ho ho und Return!",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.25":
    "Nikolaus wartet am Netz.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.26":
    "Festlicher Start in die Woche.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.27":
    "Wer kommt, wird belohnt (mit Spielzeit).",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.28":
    "Nikolaus-Special auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.29":
    "Schokolade später – erst das Doppel.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.intro.30":
    "Kurz: Nikolaus fragt nach eurer Zusage.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.01":
    "Süßes oder saures Match? Bitte melden! 🍫",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.02":
    "Bitte zusagen – Nikolaus notiert mit.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.03":
    "Ja/Nein – sonst gibt’s nur Kohle-Memes.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.04":
    "Rückmeldung bitte, danke!",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.05":
    "Wer brav ist, meldet sich schnell.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.06":
    "Kurzes Lebenszeichen an den Nikolaus.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.07":
    "Antwort erbeten – festlich aber klar.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.08":
    "Melden lohnt sich. Versprochen.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.09":
    "Eine Nachricht reicht völlig.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.10":
    "Bitte Feedback vor dem Stiefel-Check.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.11":
    "Zusagen = Geschenk. Absagen = ehrlich.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.12":
    "Sagt Bescheid, dann steht die Aufstellung.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.13":
    "Hohoho – und bitte antworten.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.14":
    "Kurzes Ja rettet den Plan.",
  "winterdoppel.whatsapp.tone.funny.nikolaus.cta.15":
    "Meldet euch, bevor Nikolaus geht.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.01":
    "Alle Jahre wieder … wer vergisst die Tennisschuhe? 🎄",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.02":
    "Weihnachtsstimmung: Doppel unter dem Netz-Baum.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.03":
    "Christkind plant die Aufstellung.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.04":
    "Glöckchen läuten – Aufschlag!",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.05":
    "Festtage nah, Vorhand warm.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.06":
    "Tannenbaum draußen, Smash drinnen.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.07":
    "Weihnachts-Edition der Hallensaison.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.08":
    "Wer kommt trotz Plätzchen-Verlockung?",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.09":
    "Stille Nacht? Nicht auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.10":
    "Festlicher Spirit, seriöse Bälle.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.11":
    "Die Woche vor Weihnachten: wir spielen trotzdem.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.12":
    "Kerzenschein war gestern – Hallenlicht heute.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.13":
    "Weihnachtsstress abladen: per Return.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.14":
    "Plätzchen später, Doppel jetzt.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.15":
    "Alle Jahre wieder… dieselbe Frage: Wer kommt?",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.16":
    "Festliche Begrüßung, klare Zusagen erwünscht.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.17":
    "Der Adventskalender hat heute: Tennis.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.18":
    "Sternschnuppen draußen, Asses drinnen.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.19":
    "Weihnachts-Doppel: Tradition!",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.20":
    "Wer absagt, muss Kekse backen. Mentales Regelwerk.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.21":
    "Glocken, Bälle, gute Laune.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.22":
    "Festtagsform prüfen – auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.23":
    "Die Halle ist euer Wohnzimmer (kurz).",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.24": "Weihnachtsmodus: an.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.25":
    "Noch ein Match vor dem Fest?",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.26":
    "Christbaumkugel vs. Tennisball – wir nehmen Ball.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.27":
    "Festliche Laune mitbringen.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.28":
    "Winterzauber inkl. Vorhand.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.29":
    "Kurz vor dem Fest: nochmal Vollgas.",
  "winterdoppel.whatsapp.tone.funny.christmas.intro.30":
    "Weihnachten kommt – ihr hoffentlich auch.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.01":
    "Engelsgeduld: bitte bis morgen melden! 🎁",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.02":
    "Bitte zusagen – sonst plane ich mit Rentieren.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.03": "Ja/Nein reicht, danke!",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.04":
    "Kurzes Lebenszeichen erbeten.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.05":
    "Melden vor dem Feststress – bitte!",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.06":
    "Antwort bitte, dann steht der Plan.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.07":
    "Zusagen willkommen, Absagen ehrlich.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.08":
    "Eine Nachricht – fertig.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.09":
    "Bitte Feedback, danke euch.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.10":
    "Wer kommt zum Weihnachts-Doppel?",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.11":
    "Sagt Bescheid, bevor das Christkind entscheidet.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.12":
    "Kurzes Ja rettet die Aufstellung.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.13":
    "Meldet euch – festlich aber klar.",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.14": "Rückmeldung bitte!",
  "winterdoppel.whatsapp.tone.funny.christmas.cta.15":
    "Hoho… äh: Bitte antworten. 🎄",
  "winterdoppel.whatsapp.tone.funny.default.intro.01":
    "Achtung, Schläger alarm!",
  "winterdoppel.whatsapp.tone.funny.default.intro.02":
    "Doppel-Call: Wer ist dabei?",
  "winterdoppel.whatsapp.tone.funny.default.intro.03":
    "Die Plätze rufen – leise, aber bestimmt.",
  "winterdoppel.whatsapp.tone.funny.default.intro.04":
    "Zeit für Tennis statt To-do-Liste.",
  "winterdoppel.whatsapp.tone.funny.default.intro.05": "Matchday in der Halle.",
  "winterdoppel.whatsapp.tone.funny.default.intro.06":
    "Wer bringt die beste Ausrede mit?",
  "winterdoppel.whatsapp.tone.funny.default.intro.07": "Aufschlag in 3… 2… 1…",
  "winterdoppel.whatsapp.tone.funny.default.intro.08":
    "Die Bälle sind ungeduldig.",
  "winterdoppel.whatsapp.tone.funny.default.intro.09":
    "Kurzes Briefing vor dem Match.",
  "winterdoppel.whatsapp.tone.funny.default.intro.10":
    "Wir brauchen euch auf dem Court.",
  "winterdoppel.whatsapp.tone.funny.default.intro.11":
    "Doppel steht an – klassikerweise.",
  "winterdoppel.whatsapp.tone.funny.default.intro.12":
    "Heute zählt Mitspielen mehr als Mitreden.",
  "winterdoppel.whatsapp.tone.funny.default.intro.13":
    "Die Aufstellung wartet auf Leben.",
  "winterdoppel.whatsapp.tone.funny.default.intro.14":
    "Schläger checken, Motivation laden.",
  "winterdoppel.whatsapp.tone.funny.default.intro.15":
    "Ein weiterer Termin, frische Chancen.",
  "winterdoppel.whatsapp.tone.funny.default.intro.16":
    "Wer kommt, gewinnt schon mental.",
  "winterdoppel.whatsapp.tone.funny.default.intro.17":
    "Hallo Motivation – bitte einloggen.",
  "winterdoppel.whatsapp.tone.funny.default.intro.18":
    "Die Halle hat freie Slots. Ihr?",
  "winterdoppel.whatsapp.tone.funny.default.intro.19":
    "Standardansage: Wir spielen.",
  "winterdoppel.whatsapp.tone.funny.default.intro.20":
    "Netz steht, Frage offen: kommt ihr?",
  "winterdoppel.whatsapp.tone.funny.default.intro.21":
    "Wieder Zeit für gute Bälle.",
  "winterdoppel.whatsapp.tone.funny.default.intro.22":
    "Kein Drama, nur Doppel.",
  "winterdoppel.whatsapp.tone.funny.default.intro.23":
    "Die Woche braucht ein Highlight.",
  "winterdoppel.whatsapp.tone.funny.default.intro.24":
    "Bitte zur Stelle – mit Vorhand.",
  "winterdoppel.whatsapp.tone.funny.default.intro.25":
    "Matchmodus aktivierbar.",
  "winterdoppel.whatsapp.tone.funny.default.intro.26": "Wir sammeln Zusagen.",
  "winterdoppel.whatsapp.tone.funny.default.intro.27": "Court calling!",
  "winterdoppel.whatsapp.tone.funny.default.intro.28":
    "Tennis > Sofa. Meistens.",
  "winterdoppel.whatsapp.tone.funny.default.intro.29":
    "Der Termin steht – die Frage auch.",
  "winterdoppel.whatsapp.tone.funny.default.intro.30":
    "Kurz und klar: Doppel-Zeit.",
  "winterdoppel.whatsapp.tone.funny.default.cta.01":
    "Wer kommt wirklich – und wer hat wieder Ausreden parat? 😄",
  "winterdoppel.whatsapp.tone.funny.default.cta.02": "Bitte kurz melden!",
  "winterdoppel.whatsapp.tone.funny.default.cta.03": "Ja/Nein reicht völlig.",
  "winterdoppel.whatsapp.tone.funny.default.cta.04":
    "Rückmeldung erbeten – danke!",
  "winterdoppel.whatsapp.tone.funny.default.cta.05":
    "Sagt Bescheid, dann planen wir final.",
  "winterdoppel.whatsapp.tone.funny.default.cta.06":
    "Kurzes Lebenszeichen bitte.",
  "winterdoppel.whatsapp.tone.funny.default.cta.07": "Melden lohnt sich.",
  "winterdoppel.whatsapp.tone.funny.default.cta.08":
    "Eine Nachricht – und wir wissen Bescheid.",
  "winterdoppel.whatsapp.tone.funny.default.cta.09": "Zusagen willkommen!",
  "winterdoppel.whatsapp.tone.funny.default.cta.10": "Bitte Feedback.",
  "winterdoppel.whatsapp.tone.funny.default.cta.11": "Kommt ihr mit?",
  "winterdoppel.whatsapp.tone.funny.default.cta.12": "Antwort bitte zeitnah.",
  "winterdoppel.whatsapp.tone.funny.default.cta.13":
    "Ja schreiben rettet den Plan.",
  "winterdoppel.whatsapp.tone.funny.default.cta.14": "Meldet euch kurz.",
  "winterdoppel.whatsapp.tone.funny.default.cta.15":
    "Wer zusagt, ist Held der Woche.",
  "winterdoppel.whatsapp.greeting.v01": "Liebe Spieler,",
  "winterdoppel.whatsapp.greeting.v02": "Den Aufschlägern der Woche,",
  "winterdoppel.whatsapp.greeting.v03": "An die mit der schnellsten Vorhand,",
  "winterdoppel.whatsapp.greeting.v04": "Liebe Doppel-Fans,",
  "winterdoppel.whatsapp.greeting.v05": "Hallo Hallen-Crew,",
  "winterdoppel.whatsapp.greeting.v06": "Liebes Team,",
  "winterdoppel.whatsapp.greeting.v07": "An die Wochen-Champions,",
  "winterdoppel.whatsapp.greeting.v08": "Hallo motivierte Schlägerträger,",
  "winterdoppel.whatsapp.greeting.v09": "An die Netz-Arbeiter der Woche,",
  "winterdoppel.whatsapp.greeting.v10": "Liebe Return-Maschine(n),",
  "winterdoppel.whatsapp.greeting.v11": "Hallo Team Vorhand,",
  "winterdoppel.whatsapp.greeting.v12": "An alle mit Matchplan,",
  "winterdoppel.whatsapp.greeting.v13": "Liebe Punktesammler,",
  "winterdoppel.whatsapp.greeting.v14": "Hallo Court-Familie,",
  "winterdoppel.whatsapp.greeting.v15": "An die Unermüdlichen,",
  "winterdoppel.whatsapp.greeting.v16": "Liebe Ballwechsel-Fans,",
  "winterdoppel.whatsapp.greeting.v17": "Hallo Zusammengehörige am Netz,",
  "winterdoppel.whatsapp.greeting.v18": "An die mit Termintreue,",
  "winterdoppel.whatsapp.greeting.v19": "Liebe Doppel-Strategen,",
  "winterdoppel.whatsapp.greeting.v20": "Hallo ihr Lieben,",
  "winterdoppel.whatsapp.greeting.v21": "An die mit guter Laune,",
  "winterdoppel.whatsapp.greeting.v22": "Liebe Mitspieler,",
  "winterdoppel.whatsapp.greeting.v23": "Hallo Saison-Helden,",
  "winterdoppel.whatsapp.greeting.v24": "An die Pünktlichen (hoffentlich),",
  "winterdoppel.whatsapp.greeting.v25": "Liebe Tennisfreunde,",
  "winterdoppel.whatsapp.greeting.v26": "Hallo ihr Wilden,",
  "winterdoppel.whatsapp.greeting.v27": "An die mit dem besten Slice,",
  "winterdoppel.whatsapp.greeting.v28": "Liebe Mitstreiter,",
  "winterdoppel.whatsapp.greeting.v29": "Hallo Doppel-Crew,",
  "winterdoppel.whatsapp.greeting.v30":
    "An euch da draußen – nein, da drinnen,",
  "winterdoppel.whatsapp.greeting.named.v01": "Hallo {{names}},",
  "winterdoppel.whatsapp.greeting.named.v02": "Hi {{names}} – kurze Ansage:",
  "winterdoppel.whatsapp.greeting.named.v03": "{{names}} – Doppel-Call!",
  "winterdoppel.whatsapp.greeting.named.v04": "Servus {{names}},",
  "winterdoppel.whatsapp.greeting.named.v05": "Moin {{names}},",
  "winterdoppel.whatsapp.greeting.named.v06": "Hey {{names}}, Zeit für Tennis:",
  "winterdoppel.whatsapp.greeting.named.v07": "{{names}}, die Plätze warten:",
  "winterdoppel.whatsapp.greeting.named.v08": "Liebe {{names}},",
  "winterdoppel.whatsapp.greeting.named.v09":
    "An {{names}} und den Rest der Crew,",
  "winterdoppel.whatsapp.greeting.named.v10": "{{names}} – seid ihr startklar?",
  "winterdoppel.whatsapp.greeting.named.v11": "Kurzer Ping an {{names}}:",
  "winterdoppel.whatsapp.greeting.named.v12": "Hallo {{names}} und Co.,",
  "winterdoppel.whatsapp.greeting.named.v13": "{{names}}, Aufschlag steht an:",
  "winterdoppel.whatsapp.greeting.named.v14":
    "Hi {{names}} – bitte kurz lesen:",
  "winterdoppel.whatsapp.greeting.named.v15": "{{names}}: Match-Info für euch.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.01":
    "Die Saison läuft – wer ist mit dabei?",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.02":
    "Herbstzeit ist Doppelzeit.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.03":
    "Ich freu mich auf euch in der Halle.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.04":
    "Gemeinsam durch den Herbst spielen.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.05":
    "Schöne Vorfreude auf den Termin.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.06":
    "Hallo zusammen – der Herbsttermin steht.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.07":
    "Wieder ein Abend nur für uns.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.08":
    "Lasst uns den Herbst genießen – auf dem Court.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.09":
    "Freu mich auf gute Bälle mit euch.",
  "winterdoppel.whatsapp.tone.emotional.autumn.intro.10":
    "Herbst-Doppel: ich bin dabei – ihr auch?",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.01":
    "Endlich wieder Hallenluft! ❄️",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.02":
    "Trotz Kälte: Ich freu mich auf euch.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.03":
    "Winterabend, warmes Doppel.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.04":
    "Schön, wenn wir uns wiedersehen.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.05":
    "Die Halle wartet auf uns.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.06":
    "Gemeinsam gegen den Winterblues.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.07":
    "Freu mich auf eure Vorhand.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.08":
    "Ein guter Termin gegen die Kälte.",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.09":
    "Serientermin mit euch – gerne!",
  "winterdoppel.whatsapp.tone.emotional.winter.intro.10":
    "Ich bin dabei – hoffentlich ihr auch.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.01":
    "Frühling in der Halle! 🌱",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.02":
    "Schöne Zeit für gute Bälle.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.03":
    "Saison-Endspurt – ich freu mich.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.04":
    "Frisch und motiviert in den Termin.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.05": "Freu mich auf euch!",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.06":
    "Noch ein paar starke Abende vor uns.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.07":
    "Frühling = gute Laune am Netz.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.08":
    "Schön, dass die Saison weitergeht.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.09":
    "Ich freu mich aufs gemeinsame Spiel.",
  "winterdoppel.whatsapp.tone.emotional.spring.intro.10":
    "Lasst uns den Frühling nutzen.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.01":
    "Nikolaus checkt die Schläger! 🎅",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.02":
    "Festliche Vorfreude aufs Doppel.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.03":
    "Nikolaus-Woche – ich freu mich auf euch.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.04":
    "Schöne Stimmung, gutes Spiel.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.05":
    "Ein besonderer Termin steht an.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.06":
    "Freu mich auf unser Nikolaus-Doppel.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.07":
    "Gemeinsam spielen in der Nikolaus-Woche.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.08":
    "Festlich und fair – so mag ich’s.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.09":
    "Ich bin dabei – ihr hoffentlich auch.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.intro.10":
    "Nikolaus bringt Stimmung, wir die Bälle.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.01":
    "Alle Jahre wieder … 🎄",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.02":
    "Vorweihnachts-Doppel – ich freu mich.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.03":
    "Schöne Adventszeit am Netz.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.04":
    "Trotz Trubel: Tennis mit euch.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.05":
    "Freu mich auf den Termin vor dem Fest.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.06":
    "Ein ruhiger Matchabend wäre schön.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.07":
    "Weihnachtsstimmung + gute Bälle.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.08":
    "Ich freu mich auf euch!",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.09":
    "Gemeinsam vor dem Fest spielen.",
  "winterdoppel.whatsapp.tone.emotional.christmas.intro.10":
    "Festliche Grüße und Doppel-Lust.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.01":
    "Freu mich auf euch!",
  "winterdoppel.whatsapp.tone.emotional.default.intro.02":
    "Schön, wieder mit euch zu spielen.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.03":
    "Ich freu mich auf den Termin.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.04": "Gute Bälle voraus!",
  "winterdoppel.whatsapp.tone.emotional.default.intro.05":
    "Gemeinsam spielen – darauf freu ich mich.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.06":
    "Wieder ein schöner Abend vor uns.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.07":
    "Freu mich auf eure Zusagen.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.08":
    "Tennis mit euch ist immer eine Freude.",
  "winterdoppel.whatsapp.tone.emotional.default.intro.09":
    "Ich bin motiviert – ihr auch?",
  "winterdoppel.whatsapp.tone.emotional.default.intro.10":
    "Auf ein gutes Match!",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.01":
    "Sagt mir bitte kurz Bescheid, ob ihr dabei seid! 🎾",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.02":
    "Bitte kurz melden – danke euch!",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.03":
    "Rückmeldung bitte, ich freu mich.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.04":
    "Wer ist dabei? Bitte Bescheid geben.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.05":
    "Kurzes Ja/Nein wäre super.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.06":
    "Meldet euch bitte zeitnah.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.07":
    "Ich plane gerne mit euren Zusagen.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.08":
    "Bitte antworten, danke!",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.09":
    "Sagt Bescheid – ich freu mich auf euch.",
  "winterdoppel.whatsapp.tone.emotional.autumn.cta.10":
    "Eine kurze Rückmeldung reicht.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.01":
    "Wer ist dabei? Meldet euch bitte – wir wärmen uns gemeinsam auf! 🧤",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.02": "Bitte zusagen, danke!",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.03":
    "Kurzes Lebenszeichen bitte.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.04":
    "Ich freu mich auf eure Rückmeldung.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.05":
    "Bitte melden, ob ihr kommt.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.06":
    "Ja/Nein reicht völlig.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.07":
    "Sagt Bescheid – trotz Kälte.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.08":
    "Rückmeldung erbeten, danke euch.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.09": "Bitte antworten.",
  "winterdoppel.whatsapp.tone.emotional.winter.cta.10": "Meldet euch kurz!",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.01":
    "Bitte kurz melden – ich freu mich!",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.02":
    "Wer kommt zum Endspurt?",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.03": "Rückmeldung bitte.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.04": "Sagt Bescheid, danke!",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.05": "Kurzes Ja/Nein.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.06": "Bitte antworten.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.07":
    "Ich plane mit euren Zusagen.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.08": "Meldet euch bitte.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.09":
    "Eine Nachricht reicht.",
  "winterdoppel.whatsapp.tone.emotional.spring.cta.10":
    "Freu mich auf eure Antwort.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.01":
    "Wer war brav und kommt? Bitte kurz melden! 🎁",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.02":
    "Bitte zusagen – danke!",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.03":
    "Kurzes Lebenszeichen bitte.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.04":
    "Rückmeldung erbeten.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.05": "Sagt Bescheid!",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.06": "Bitte antworten.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.07": "Ja/Nein reicht.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.08": "Meldet euch bitte.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.09":
    "Ich freu mich auf eure Zusage.",
  "winterdoppel.whatsapp.tone.emotional.nikolaus.cta.10":
    "Kurze Rückmeldung – danke.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.01":
    "Frohe Vorfreude – wer spielt mit? Bitte kurz antworten! ✨",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.02":
    "Bitte melden, danke!",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.03": "Kurzes Ja/Nein.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.04": "Rückmeldung bitte.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.05":
    "Sagt Bescheid vor dem Fest.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.06": "Bitte antworten.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.07":
    "Ich freu mich auf euch.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.08": "Meldet euch kurz!",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.09":
    "Eine Nachricht reicht.",
  "winterdoppel.whatsapp.tone.emotional.christmas.cta.10":
    "Bitte Zusagen senden.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.01":
    "Sagt mir bitte kurz Bescheid, ob ihr dabei seid! 🎾",
  "winterdoppel.whatsapp.tone.emotional.default.cta.02": "Bitte kurz melden!",
  "winterdoppel.whatsapp.tone.emotional.default.cta.03": "Rückmeldung erbeten.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.04": "Ja/Nein reicht.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.05":
    "Sagt Bescheid – danke!",
  "winterdoppel.whatsapp.tone.emotional.default.cta.06": "Bitte antworten.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.07": "Meldet euch bitte.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.08":
    "Kurzes Lebenszeichen.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.09":
    "Ich freu mich auf eure Zusage.",
  "winterdoppel.whatsapp.tone.emotional.default.cta.10":
    "Eine Nachricht reicht.",
};
